import React from 'react';
import { cn } from '@frontend/shadcn/lib/utils';
import {
  ChevronRightIcon,
  ShuffleIcon,
} from '@revfluence/fresh-icons/regular/esm';
import {
  CircleExclamationIcon,
} from '@revfluence/fresh-icons/solid/esm';
import { FilledIconContainer, getNewStageIconsFilled, WorkletSpecUri } from '../../constants';
import { CreatorTaskConfig } from '../CampaignContext';

export const StageToCreatorInteractionMap = {
  [WorkletSpecUri.SendTermsWorkletSpecification]: 'Review and Sign Brief',
  [WorkletSpecUri.ReviewContentWorkletSpecification]: 'Submit Content',
  [WorkletSpecUri.CreatorProductSelectionWorkletSpecification]: 'Select Products',
  [WorkletSpecUri.SendBrandProductCatalogWorkletSpecification]: 'Select Products',
  [WorkletSpecUri.OfflineCreatorProductSelectionWorkletSpecification]: 'Select Products',
  [WorkletSpecUri.ConfirmAddressWorkletSpecification]: 'Confirm Info',
  [WorkletSpecUri.PromoCodesWorkletSpecification]: 'View Promo Code',
  [WorkletSpecUri.SalesLinkWorkletSpecification]: 'View Sales Link',
  [WorkletSpecUri.SalesLinkPromoCodesWorkletSpecification]: 'View Offer',
};

interface Props {
  task: CreatorTaskConfig;
  isBlocked: boolean;
}

export const TaskItem: React.FC<Props> = ({ task, isBlocked }) => {
  const title = StageToCreatorInteractionMap[task.specURI] || task.specTitle;
  const stageIcon = getNewStageIconsFilled('h-6 w-6')[task.specURI] || (
    <FilledIconContainer className="bg-grey-4">
      <ShuffleIcon />
    </FilledIconContainer>
  );

  // If the first task is initial, then the following tasks are blocked
  const status = isBlocked && task.order !== 0 ? 'waiting' : 'active';

  if (!title || !stageIcon) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-xl border border-grey-2 px-3 py-1.5',
        status === 'waiting' ? 'bg-grey-1' : 'bg-white'
      )}
    >
      {stageIcon}
      <div className="flex-1">
        <p className="mb-0 text-sm font-medium text-grey-6">{title}</p>
        {status === 'waiting' && (
          <p className="mb-0 text-xs text-primaryMuted">Waiting</p>
        )}
      </div>
      {/* Status Indicator (Example based on Review Brief) */}
      {status === 'active' && (
        <div className="flex items-center gap-2">
          <div className="flex h-6 w-6 items-center justify-center rounded-md bg-yellow-2">
            <CircleExclamationIcon fontSize={12} className="text-warning" />{/* Assuming yellow-6 is dark yellow */}
          </div>
          <ChevronRightIcon fontSize={12} className="text-grey-6" />
        </div>
      )}
    </div>
  );
};
